<template>
  <div class="my-4">
    <form class="shadowbox form">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group">
                <div class="grouped-input w-100">
                  <label for="ID_nachname">Nachname*</label>
                  <input v-model="nachname" id="ID_nachname" type="text" name="nm_nachname" />
                </div>
              </div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group">
                <div class="grouped-input w-100">
                  <label for="ID_vorname">Vorname*</label>
                  <input v-model="vorname" id="ID_vorname" type="text" name="nm_vorname" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group">
                <div class="grouped-input w-100">
                  <label for="ID_email">Email*</label>
                  <input v-model="email" id="ID_email" type="text" name="nm_email" />
                </div>
              </div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group">
                <div class="grouped-input w-100">
                  <label for="ID_telefon">Telefon</label>
                  <input v-model="telefon" id="ID_telefon" type="text" name="nm_telefon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <p class="col-sm-12" :class="[!(valid.vorname && valid.nachname) ? 'text-danger' : '']">
          Die mit einem Stern (*) gekennzeichneten Felder sind Pflichtfelder.
          <span class="text-danger" v-if="valid.msg.length != 0">{{ valid.msg }}</span>
        </p>
      </div>
      <div class="row my-2">
        <div class="col-sm-12">
          <div class="form-check">
            <!-- style="font-size:100%;color:#000;margin-bottom:10px;" -->
            <input type="checkbox" class="form-check-input " id="idDSGVO" name="nm_dsgvo" ref="refDSGVO" @change="validation()" />
            <label :class="{ 'text-danger': !dsgvoChecked }" class="lblDSGVO" for="idDSGVO"
              ><a :href="lang.linkdatenschutz" target="_blank">Datenschutzerklärung</a> gelesen und akzeptiert</label
            >
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-sm-4 col-md-2 pl-3">
          <button class="nk-form nk-button darkbutton pointer" type="button" @click="absenden()" name="nm_absenden">
            Absenden
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Formular',
  props: {
    lang: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nachname: '',
      vorname: '',
      email: '',
      telefon: '',
      valid: {
        nachname: false,
        vorname: false,
        email: false,
        msg: '',
      },
    }
  },
  computed: {
    validEMail() {
      return /(.+)@(.+){2,}\.(.+){2,}/.test(this.email)
    },
    dsgvoChecked() {
      return this.$refs.refDSGVO && this.$refs.refDSGVO.checked ? false : true
    },
    $env() {
      return {
        companyUrl: process.env.VUE_APP_COMPANY_URL,
      }
    },
  },
  watch: {
    nachname() {
      this.validation()
    },
    vorname() {
      this.validation()
    },
    email() {
      this.validation()
    },
  },
  methods: {
    absenden() {
      if (this.validation()) {
        let interessent = {
          nachname: this.nachname,
          vorname: this.vorname,
          email: this.email,
          telefon: this.telefon,
        }
        this.$emit('absenden', interessent)
      }
    },
    validation() {
      let bValid = true
      this.nachname.length === 0 ? (this.valid.nachname = bValid = false) : (this.valid.nachname = true)
      this.vorname.length === 0 ? (this.valid.vorname = bValid = false) : (this.valid.vorname = true)
      this.email.length === 0 ? (this.valid.email = bValid = false) : (this.valid.email = true)

      // Leer: Name/Vorname/Email
      if (bValid === false) {
        //this.valid.msg = "Bitte Pflichtfeder ausfüllen.";
        return false
      }
      // Invalide E-Mail
      if (!this.validEMail) {
        this.valid.msg = 'Ungültige Email Adresse.'
        this.valid.email = false
        return false
      } else {
        this.valid.email = true
      }
      this.valid.msg = ''

      // DSGVO nicht angehakt
      if (this.$refs.refDSGVO.checked == false) {
        this.valid.msg = 'Bitte Datenschutzerklärung beachten.'
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss"></style>
